import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editOteFpa = ( {data, oteFpaId} : {data: IPostEditOteFpa | {}, oteFpaId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/OteFpa/UpdateOteFpa/${oteFpaId}`, data);
};

type QueryFnType = typeof editOteFpa;

type UseEditOteFpaOptions = {
  data: IPostEditOteFpa | {};
  oteFpaId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditOteFpa = ({ config }: UseEditOteFpaOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Κατηγορίας ΦΠΑ.`, 500);
            console.error('Couldnt edit OteFpa', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllOteFpas"])
            addNotification('Η Κατηγορία ΦΠΑ Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editOteFpa,
    })
}